import { render } from "./AppCheckBox.vue?vue&type=template&id=3396ab3e"
import script from "./AppCheckBox.vue?vue&type=script&lang=ts"
export * from "./AppCheckBox.vue?vue&type=script&lang=ts"
script.render = render

export default script